import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { repository } from '../../repositories/index.js';
import { useAuthSession } from './AuthSession.js';

export function LoginPage() {
  const navigate = useNavigate();
  const session = useAuthSession();
  const apiMode = repository.mode === 'api';
  const [tenantSlug, setTenantSlug] = React.useState(apiMode ? 'mosoboi' : 'mosoboi');
  const [email, setEmail] = React.useState(apiMode ? '' : 'owner@mosoboi.example');
  const [password, setPassword] = React.useState(apiMode ? '' : 'demo');
  const [busy, setBusy] = React.useState(false);

  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setBusy(true);
    try {
      const result = await repository.login({ tenantSlug, email, password });
      if (result.state === 'mfa_required') {
        navigate('/auth/mfa');
        return;
      }
      session.acceptAuthenticated(result.context);
      navigate('/tenant/catalog?query=R28003');
    } catch {
      session.clearSession();
      navigate('/auth/error?reason=login');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="auth-page">
      <section className="auth-card">
        <span className="brand auth-brand">DataSota</span><p className="eyebrow">ЕДИНАЯ ТОЧКА ВХОДА</p><h1>Войти в DataSota</h1>
        <p>После проверки сервер направит пользователя в разрешённый контекст.</p>
        {!apiMode ? <div className="mock-auth-hint">Mock: email с «mfa» открывает MFA, с «error» — ошибку.</div> : null}
        <form onSubmit={submit}>
          {apiMode ? <label>Тенант<input type="text" value={tenantSlug} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setTenantSlug(event.currentTarget.value)} autoComplete="organization" required /></label> : null}
          <label>Email<input type="email" value={email} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setEmail(event.currentTarget.value)} autoComplete="username" required /></label>
          <label>Пароль<input type="password" value={password} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setPassword(event.currentTarget.value)} autoComplete="current-password" required /></label>
          <button type="submit" className="button primary full-width" disabled={busy}>{busy ? 'Проверка…' : 'Продолжить'}</button>
        </form>
        <small>Frontend не принимает авторизационные решения; доступ и tenant context определяет Backend.</small>
      </section>
    </main>
  );
}

export function MfaPage() {
  const navigate = useNavigate();
  const session = useAuthSession();
  const [code, setCode] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setBusy(true);
    try {
      const context = await repository.verifyMfa(code);
      session.acceptAuthenticated(context);
      navigate('/tenant/catalog?query=R28003');
    } catch {
      session.clearSession();
      navigate('/auth/error?reason=mfa');
    } finally {
      setBusy(false);
    }
  };
  return (
    <main className="auth-page">
      <section className="auth-card">
        <span className="brand auth-brand">DataSota</span><p className="eyebrow">МНОГОФАКТОРНАЯ ПРОВЕРКА</p><h1>Введите код</h1>
        <p>Код из приложения-аутентификатора. Секрет MFA не хранится во frontend.</p>
        <form onSubmit={submit}>
          <label>Шестизначный код<input inputMode="numeric" pattern="[0-9]{6}" maxLength={6} value={code} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setCode(event.currentTarget.value.replace(/\D/g, ''))} autoComplete="one-time-code" required /></label>
          <button type="submit" className="button primary full-width" disabled={busy}>{busy ? 'Проверка…' : 'Подтвердить'}</button>
        </form>
        <button type="button" className="button text-button full-width" onClick={() => navigate('/auth/login')}>Вернуться ко входу</button>
      </section>
    </main>
  );
}

export function AuthErrorPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const apiMode = repository.mode === 'api';
  const reason = new URLSearchParams(location.search).get('reason');
  const heading = reason === 'session-expired' ? 'Сессия завершена' : 'Не удалось продолжить';
  return (
    <main className="auth-page">
      <section className="auth-card error-card">
        <span className="brand auth-brand">DataSota</span><p className="eyebrow">СЕССИЯ</p><h1>{heading}</h1>
        <p>Сессия недействительна или проверка завершилась ошибкой. Никакие данные тенанта не открыты.</p>
        <div className="auth-error-box">{apiMode ? 'Авторизация не завершена. Повторите вход через Backend DataSota.' : 'Mock-состояние ошибки аутентификации / сессии'}</div>
        <button type="button" className="button primary full-width" onClick={() => navigate('/auth/login')}>Вернуться ко входу</button>
      </section>
    </main>
  );
}
